import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import StatisticFuturesUSDM from '@pages/StatisticPage/StatisticFuturesUSDM';
import { flowRight } from 'lodash';

export default flowRight(withVerificationGuard, withAuthGuard())(StatisticFuturesUSDM);
